import { matchPath } from 'react-router'
import { REPORTING_DOCUMENT_TYPES } from '@common/constants/client'
import { select, takeEvery } from 'redux-saga/effects'
import { ROUTES } from '../../constants/routes'
import { putPromise } from '../../helpers/redux'
import { DELETE_ALIAS_SUCCESS, UPDATE_ALIAS_SUCCESS } from '../aliases/actions'
import { ongoingReporting } from '../ongoingReporting/selectors'
import { showOngoingReporting } from './../ongoingReporting/actions'
import { UPDATE_GENERAL_LEDGER_SUCCESS, UPDATE_TYPE_MAPPING_SUCCESS } from './actions'

export function* refreshOngoingReporting() {
  yield takeEvery(
    [
      UPDATE_GENERAL_LEDGER_SUCCESS,
      UPDATE_ALIAS_SUCCESS,
      DELETE_ALIAS_SUCCESS,
      UPDATE_TYPE_MAPPING_SUCCESS,
    ],
    function* () {
      if (
        matchPath(
          {
            path: ROUTES.ONGOING_REPORTING_AR_GENERAL_LEDGER,
          },
          window.location.pathname,
        )
      ) {
        const { id, type } = (yield select(ongoingReporting)) as { id: string; type: string }
        if (id && type && type === REPORTING_DOCUMENT_TYPES.arGeneralLedger) {
          yield putPromise(showOngoingReporting(id))
        }
      }
    },
  )
}
